import { render, staticRenderFns } from "./pExpertIndex.vue?vue&type=template&id=28aef10d&scoped=true"
import script from "./pExpertIndex.vue?vue&type=script&lang=js"
export * from "./pExpertIndex.vue?vue&type=script&lang=js"
import style0 from "./pExpertIndex.vue?vue&type=style&index=0&id=28aef10d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aef10d",
  null
  
)

export default component.exports